import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import HeroSection from '../components/home/HeroSection';
import StatsSection from '../components/home/StatsSection';
import CampaignHighlight from '../components/home/CampaignHighlight';
import RecentDonations from '../components/home/RecentDonations';
import SponsorSection from '../components/home/SponsorSection';
import './MainPage.css';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <CampaignHighlight />
        <RecentDonations />
        <SponsorSection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
